import { Directive, HostListener, Input, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appFileUpload]'
})
export class FileUploadDirective {
  @Input() maxFileSize = 2; // MB
  @Input() extensions: string[] = ['jpg', 'jpeg', 'png']; // default allowed extensions

  @Output() fileSelected = new EventEmitter<{ file: File | null, preview: string | null }>();
  @Output() fileTypeError = new EventEmitter<boolean>();
  @Output() fileSizeError = new EventEmitter<boolean>();

  @HostListener('change', ['$event'])
  onChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (file && this.validateFile(file)) {
      this.readFile(file);
    } else {
      this.fileSelected.emit({ file: null, preview: null });
    }
  }

  private readFile(file: File): void {
    const reader = new FileReader();
    reader.onloadend = () => {
      this.fileSelected.emit({ file, preview: reader.result as string });
    };
    reader.readAsDataURL(file);
  }

  private validateFile(file: File): boolean {
    const extension = this.getFileExtension(file.name);
    if (!extension || !this.extensions.includes(extension)) {
      this.fileTypeError.emit(true);
      return false;
    }
    this.fileTypeError.emit(false);

    const sizeInMB = file.size / (1024 * 1024);
    if (sizeInMB > this.maxFileSize) {
      this.fileSizeError.emit(true);
      return false;
    }
    this.fileSizeError.emit(false);

    return true;
  }

  private getFileExtension(fileName: string): string | null {
    return fileName.split('.').pop()?.toLowerCase() || null;
  }
}
